@if (viewState$ | async; as viewState) {
    <ng-scrollbar
        #modalContent
        class="reward-tokens-info ng-scrollbar-compact"
        [ngClass]="{ 'acca-boost-model': accaBoostSelected || hideTabs }"
        [class.reward-tokens-info--cover-quick-bet]="viewState.coverQuickBet">
        @if (!isRewardDrawerEnabled) {
            <div class="reward-tokens-info__content tokens-info">
                @if (!hideTabs) {
                    <div class="tabs-grouping">
                        <ds-tabs-group
                            msThemedTabs
                            class="tabs-allignment"
                            fullWidthTabs="true"
                            size="large"
                            variant="horizontal"
                            [scrollable]="false"
                            [inverse]="true"
                            [themedInverse]="getThemeInverseIndicator()"
                            [activeTab]="getActiveTab()"
                            (activeTabChange)="tabSelected($event)">
                            @if (viewState.accaBoostContent) {
                                <ds-tab [name]="rewardTokenInfoType.AccaBoost">
                                    <ng-container *dsTabHeader>
                                        <span (click)="handleClick(true)">
                                            {{ viewState.accaBoostContent.title }}
                                        </span>
                                    </ng-container>
                                </ds-tab>
                            }
                            @if (viewState.rewardTokenMessage) {
                                <ds-tab [name]="rewardTokenInfoType.Rewards">
                                    <ng-container *dsTabHeader>
                                        <span (click)="handleClick(false)">
                                            {{ viewState.rewardTokenTitle }}
                                        </span>
                                    </ng-container>
                                </ds-tab>
                            }
                            <ds-divider />
                        </ds-tabs-group>
                    </div>
                }
                <div class="reward-tokens-info__tab-content">
                    @if (accaBoostSelected || hideTabs) {
                        <div class="acca-boost-info__message-container">
                            <ng-container *ngTemplateOutlet="accaBoostTemplate; context: { viewState: viewState }" />
                        </div>
                    } @else {
                        <div class="reward-tokens-info__message-container" [innerHtml]="viewState.rewardTokenMessage"></div>
                    }
                    <div class="reward-tokens-info__button" (click)="closeClick($event, true)">{{ sitecore.betslip.messages.BankerHelpClose }}</div>
                </div>
            </div>
        } @else {
            <div class="reward-tokens-info__container">
                <div class="reward-tokens-info__message-container promotions-container" [innerHtml]="viewState.rewardTokenMessage"></div>
                <div class="tokens-list-footer">
                    <button class="tokens-button-ok" (click)="closeClick($event, true)">
                        <span>{{ sitecore.crmTokens.messages.InfoOkButton }}</span>
                    </button>
                </div>
            </div>
        }
    </ng-scrollbar>
}
<ng-template #accaBoostTemplate let-viewState="viewState">
    <ng-container class="acca-boost-container">
        @if (viewState.accaBoostContent) {
            <div class="acca-boost-title-description">
                <div class="acca-boost-title">
                    <span class="acca-boost-icon theme-acca-boost"></span>
                    <div [ngClass]="{ selected: accaBoostSelected }">
                        {{ viewState.accaBoostContent.title }}
                    </div>
                </div>
                <div class="acca-boost-info__description" [innerHtml]="viewState.accaBoostContent.accaBoostDescription"></div>
            </div>
            <div class="acca-boost-minodds-max-reward">
                <div>
                    <span>{{ viewState.accaBoostContent.accaBoostMinOdds }}</span> {{ viewState.accaBoostContent.minOdds }}
                </div>
                <div>
                    <span>{{ viewState.accaBoostContent.accaBoostMaxBoost }}</span> {{ viewState.accaBoostContent.maxBoostValue | bsCurrency: true }}
                </div>
            </div>
        }
        <div class="acca-boost-sports-list">
            <div class="acca-boost-info__sports-title">{{ viewState.accaBoostContent.accaBoostWhatSports }}</div>
            @if (viewState.accaBoostContent) {
                <div class="acca-boost-info__sports-info">
                    @for (sport of viewState.accaBoostContent.sports; track sport) {
                        <div class="acca-boost-sports-container">
                            <span class="icon sports-{{ sport?.id }}"></span>
                            <span class="acca-boost-sport-name"> {{ sport.name }}</span>
                        </div>
                    }
                </div>
            }
        </div>

        <div class="acca-boost-info__ladder">
            <div class="acca-boost-ladder-offer">{{ viewState.accaBoostContent.accaBoostWhatYouCanGet }}</div>
            @if (viewState.accaBoostContent.ladder.length) {
                <div class="acca-boost-offer" [ngClass]="{ show: show }">
                    @for (ladder of viewState.accaBoostContent.ladder; track ladder) {
                        <div class="acca-boost-ladder-offer-info">
                            {{ ladder.numberOfLegs }} {{ viewState.accaBoostContent.accaBoostSelections }} -
                            <span>{{ ladder.ratio | msAccaBoostRatio: false }}</span>
                        </div>
                    }
                </div>
            }
            @if (viewState.accaBoostContent.ladder.length > 6) {
                <div class="show-more-btn" (click)="show = !show">
                    {{ show ? viewState.accaBoostContent.accaBoostShowLess : viewState.accaBoostContent.accaBoostShowMore }}
                </div>
            }
        </div>
    </ng-container>
</ng-template>
